import {initReactI18next} from "react-i18next"

import i18n from "i18next"
import Backend from "i18next-http-backend"

let currentLang: string = "FR"

switch (currentLang) {
    case "en":
        currentLang = "en-EN"
        break

    default:
        currentLang = "fr-FR"
        break
}

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        fallbackLng: "fr",
        saveMissing: true,
        lng: currentLang,
        interpolation: {
            escapeValue: true
        },
        react: {
            useSuspense: true
        },
        ns: ["document", "documentstatus", "flowstatus", "common"],
        defaultNS: "common",
        backend: {
            // Cache-bust each static translation file (public/locales/*.json) with a
            // per-file content hash injected at build time, so a deployment forces
            // browsers/CDN to refetch only the files whose content actually changed.
            loadPath: (lngs: string[], namespaces: string[]): string => {
                const lng = lngs[0]
                const ns = namespaces[0]
                const hash = __LOCALES_HASHES__[`${lng}/${ns}`]

                return `/locales/${lng}/${ns}.json${hash ? `?v=${hash}` : ""}`
            }
        }
    })

export default i18n
